import { render, staticRenderFns } from "./BaseImagePicker.vue?vue&type=template&id=213062e4&scoped=true"
import script from "./BaseImagePicker.vue?vue&type=script&lang=js"
export * from "./BaseImagePicker.vue?vue&type=script&lang=js"
import style0 from "./BaseImagePicker.vue?vue&type=style&index=0&id=213062e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213062e4",
  null
  
)

export default component.exports